<div class="fui-layout-header">
  <div class="fui-breadcrumbs m-b-30">
    <ul>
      @for (crumb of translatedBreadcrumbs; track crumb; let last = $last) {
        <li>
          @if (crumb.routerLink) {
            <a [routerLink]="crumb.routerLink">{{ crumb.label }}</a>
          }
          @if (crumb.clickHandler && !crumb.routerLink) {
            <a href="javascript:void(0);" (click)="crumb.clickHandler()">{{ crumb.label }}</a>
          }
          @if (!crumb.routerLink && !crumb.clickHandler) {
            <span>{{ crumb.label }}</span>
          }
        </li>
        @if (!last) {
          <li>&bull;</li>
        }
      }
    </ul>
  </div>
  <fui-heading [text]="translatedHeadingText" level="1" fontSize="f11"></fui-heading>
  @if (translatedDescription && showDescription) {
    <p class="m-t-20">{{ translatedDescription }}</p>
  }
  <ng-content></ng-content>
</div>
